import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { setupListeners } from '@reduxjs/toolkit/query'
import config from '@/config'
import agentSmithApi from './agent-smith/agent-smith.slice'
import backendApi from './backend/backend.slice'
import billingApi from './billing/billing.slice'
import inboxApi from './inbox/inbox.slice'
import integrationsApi from './integrations/integrations.slice'
import loyaltyApi from './loyalty/loyalty.slice'
import morpheusApi from './morpheus/morpheus.slice'
import neoApi from './neo/neo.api'
import tankApi from './tank/tank.slice'
import { rootReducer } from './reducers'
import reportsApi from './reports/reports.slice'
import rootSaga from './sagas'
import serviceApi from './service/service.slice'
import wifiApi from './wifi/wifi.slice'
import zionApi from './zion/zion.slice'
import sitesApi from './sites/sites.slice'
import cypherApi from './cypher/cypher.slice'
import { notificationsApi } from './notifications/notifications.slice'
import vpnApi from './vpn/vpn.api'
import trunkApi from './trunk/trunk.slice'
import netxlApi from './netxl/netxl.api'
import eveApi from './eve/eve.slice'
import operatorApi from './operator/operator.slice'
import mouseApi from './mouse/mouse.slice'

const createStore = (preloadedState: any = {}) => {
  const sagaMiddleware = createSagaMiddleware()

  const theStore = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware: any) =>
      getDefaultMiddleware({
        serializableCheck: false,
        ignoredActions: [],
      })
        .concat(sagaMiddleware)
        .concat(backendApi.middleware)
        .concat(serviceApi.middleware)
        .concat(morpheusApi.middleware)
        .concat(neoApi.middleware)
        .concat(tankApi.middleware)
        .concat(wifiApi.middleware)
        .concat(zionApi.middleware)
        .concat(integrationsApi.middleware)
        .concat(reportsApi.middleware)
        .concat(inboxApi.middleware)
        .concat(billingApi.middleware)
        .concat(loyaltyApi.middleware)
        .concat(agentSmithApi.middleware)
        .concat(sitesApi.middleware)
        .concat(cypherApi.middleware)
        .concat(notificationsApi.middleware)
        .concat(vpnApi.middleware)
        .concat(trunkApi.middleware)
        .concat(netxlApi.middleware)
        .concat(eveApi.middleware)
        .concat(operatorApi.middleware)
        .concat(mouseApi.middleware),
    preloadedState,
    enhancers: (getDefaultEnhancers: any) =>
      getDefaultEnhancers({
        autoBatch: { type: 'raf' },
      }),

    // enhancers: (defaultEnhancers: any) => [enhancers, ...defaultEnhancers],
    devTools: !config.prod,
  })

  setupListeners(theStore.dispatch)

  sagaMiddleware.run(rootSaga)

  return theStore
}

export type AppDispatch = ReturnType<typeof createStore>['dispatch']
export type RootState = ReturnType<typeof createStore>['getState']

export default createStore
